<template>
  <div id="mb-coding" class="mb-coding" @click="cancelCheckStatus()">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: setValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setValue(startGameConfig.mainImage.height, 1080) + 'px',
        top: setValue(startGameConfig.mainImage.pos.x, 0) + 'px',
        left: setValue(startGameConfig.mainImage.pos.y, 0) + 'px',
      }"
    />
    <!-- <div class="curtain" @click="cancelCheck()" v-if="endGame"></div> -->
    <div class="main-container">
      <div class="table-container">
        <div class="row" v-if="!startGameConfig.withoutKey">
          <div
            class="row-number"
            v-for="(num, numId) in table[0].length + 1"
            :key="'mb-coding-num-row-' + numId"
            v-html="letAlphabet(numId)"
            :style="{
              width: setValue(startGameConfig.width, 100) + 'px',
              height: setValue(startGameConfig.height, 100) + 'px',
            }"
          ></div>
        </div>
        <div class="row" v-for="(row, rowId) in table" :key="'mb-coding-row-' + rowId">
          <div
            v-if="!startGameConfig.withoutKey"
            class="row-number"
            :style="{
              width: setValue(startGameConfig.width, 100) + 'px',
              height: setValue(startGameConfig.height, 100) + 'px',
            }"
          >
            {{ rowId + 1 }}
          </div>
          <div
            class="row-item"
            v-for="(it, itId) in row"
            :key="'mb-coding-row-item-' + itId"
            @click="setColor(rowId, itId, it.block)"
            :style="[
              {
                background: it.actualColor,
                width: setValue(startGameConfig.width, 100) + 'px',
                height: setValue(startGameConfig.height, 100) + 'px',
              },
              it.block ? { cursor: 'auto' } : {},
            ]"
          >
            <transition name="img-fade">
              <img v-if="it.src" :src="it.src" />
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div class="colors">
      <hr />
      <div class="color-box" :style="{ textAlign: 'left' }">
        <div
          class="color"
          :style="{
            background: 'white',
            width: setValue(startGameConfig.width, 100) + 'px',
            height: setValue(startGameConfig.height, 100) + 'px',
          }"
          @click="setActualColor({ color: 'white' })"
        ></div>
      </div>
      <hr />
      <div v-for="(color, colorId) in colors" :key="'mb-coding-color-' + colorId" :style="{ textAlign: 'left' }">
        <div class="color-box">
          <div
            class="color"
            :style="{
              background: color.color,
              width: setValue(startGameConfig.width, 100) + 'px',
              height: setValue(startGameConfig.height, 100) + 'px',
            }"
            @click="setActualColor(color)"
          >
            <!-- <transition name="img-fade"> -->
            <img v-if="color.src" :src="giveMeImagePlease(color.src)" />
            <!-- </transition> -->
          </div>
          <div class="code" :style="{ maxWidth: 'calc(90% - ' + setValue(startGameConfig.width, 100) + 'px)' }">
            {{ color.code }}
          </div>
        </div>
        <hr />
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import defaultMixin from '../../mixins/defaultMixin';
import { Howler } from 'howler';
export default {
  name: 'mb-coding',
  components: {},
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      table: [],
      colors: [],
      actualColor: { color: '', src: null },
      endGame: false,
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    setValue(value, defaultVal) {
      return value ? value : defaultVal;
    },
    setActualColor(color) {
      if (color.src) {
        this.actualColor.src = color.src;
      } else this.actualColor.src = null;
      if (color.color) this.actualColor.color = color.color;
    },
    cancelCheckStatus() {
      if (this.gameCheckSwitch) this.$store.commit('CHANGE_CHECK_SWITCH', false);
    },
    setColor(rowId, itId, block) {
      if (!block) {
        if (this.actualColor.color != '') {
          this.table[rowId][itId].actualColor = this.actualColor.color;
          if (this.actualColor.src) {
            this.table[rowId][itId].src = this.giveMeImagePlease(this.actualColor.src);
          } else {
            this.table[rowId][itId].src = null;
          }

          setTimeout(() => {
            if (this.checkAll()) {
              this.$store.dispatch('checkGame');
              this.endGame = true;
            }
          }, 100);
        }
      }
    },
    letAlphabet(num) {
      if (num != 0) {
        return '' + String.fromCharCode(97 + num - 1).toUpperCase();
      } else return '';
    },
    checkAll() {
      let check = true;
      this.table.forEach((row) => {
        row.forEach((it) => {
          if (it.actualColor != it.color) {
            check = false;
            console.log(it);
          }
        });
      });
      return check;
    },
    initNormalMode() {
      let tmpTable = _.cloneDeep(this.startGameConfig.table);
      this.colors = _.cloneDeep(this.startGameConfig.colors);
      let tableArray = [];
      let rowId = 0;
      tmpTable.forEach((row) => {
        let array = [];
        let itId = 0;
        row.forEach((it) => {
          let itColor = 'white';
          let src = null;
          if (it.color == 0) {
            itColor = 'white';
          } else itColor = this.colors[parseInt(it.color) - 1].color;
          if (it.src) src = this.giveMeImagePlease(it.src);
          array.push({
            colorId: it.color,
            block: it.block,
            src: src,
            itemId: this.letAlphabet(itId + 1),
            rowId: rowId + 1,
            actualColor: 'white',
            color: itColor,
          });
          if (it.color != 0) {
            this.colors[parseInt(it.color) - 1].code =
              this.colors[parseInt(it.color) - 1].code + this.letAlphabet(itId + 1) + (rowId + 1) + ', ';
          }
          itId++;
        });
        rowId++;
        tableArray.push(array);
      });
      this.table = tableArray;
    },
    initRandomMode() {
      this.colors = [];
      for (let i = 0; i < this.startGameConfig.randomMode.colors; i++) {
        this.colors.push({ color: this.getRandomColor(), code: '' });
      }
      let tmpArray = [];
      for (let x = 0; x < this.startGameConfig.randomMode.row; x++) {
        let insideArray = [];
        for (let y = 0; y < this.startGameConfig.randomMode.columns; y++) {
          insideArray.push({ color: this.randomNumber(this.startGameConfig.randomMode.colors + 1, 0) });
        }
        tmpArray.push(insideArray);
      }
      let tableArray = [];
      let rowId = 0;
      tmpArray.forEach((row) => {
        let array = [];
        let itId = 0;
        row.forEach((it) => {
          let itColor = 'white';
          let src = null;
          if (it.color == 0) {
            itColor = 'white';
          } else itColor = this.colors[parseInt(it.color) - 1].color;
          if (it.src) src = this.giveMeImagePlease(it.src);
          array.push({
            colorId: it.color,
            block: it.block,
            src: src,
            itemId: this.letAlphabet(itId + 1),
            rowId: rowId + 1,
            actualColor: 'white',
            color: itColor,
          });
          if (it.color != 0) {
            this.colors[parseInt(it.color) - 1].code =
              this.colors[parseInt(it.color) - 1].code + this.letAlphabet(itId + 1) + (rowId + 1) + ', ';
          }
          itId++;
        });
        rowId++;
        tableArray.push(array);
      });
      this.table = tableArray;
    },
    init() {
      if (this.startGameConfig.randomMode) {
        this.initRandomMode();
      } else {
        this.initNormalMode();
      }
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    cancelCheck() {
      this.endGame = false;
      this.$store.commit('CHANGE_CHECK_SWITCH', false);
    },
    checkGameAction() {
      return this.checkAll();
    },
    resetGameAction() {
      console.log('reseet');
      this.table.forEach((row) => {
        row.forEach((it) => {
          it.actualColor = 'white';
          it.src = null;
        });
      });
      this.init();
      this.actualColor = { color: '', src: null };
      this.endGame = false;
    },

    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
  },
  beforeDestroy() {},
  computed: {
    gameCheckSwitch() {
      return this.$store.getters.gameCheckSwitch;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 1030px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.mb-coding
  background-size: contain
  background-repeat: no-repeat
  position: relative
  left: $backgroundOffsetLeft
  overflow: hidden
  height: 1080px
  width: 1920px
  top: 0px
  font-family: $gameFontFamily
  .curtain
    width: 100%
    height: 100%
    position: absolute
    top: 0
    left: 0
    z-index: 10
  .main-container
    width: 80%
    height: 100%
    display: flex
    justify-content: center
    align-items: center
    .table-container
      box-shadow: 0 0 10px 5px rgba(0,0,0,0.3)
      .row-number
        width: 100px
        height: 100px
        background: darkgray
        margin: 2px
        display: flex
        justify-content: center
        align-items: center
        font-size: 32px
      .row
        background: black
        padding: 0
        .row-item
          margin: 2px
          cursor: pointer
          transition: .5s
          position: relative
          img
            width: 100%
            height: 100%
            position: absolute
            top: 0
            left: 0
            transition: .5s
  // .main-container:first-child
  .colors
    position: absolute
    right: 0
    padding: 15px
    width: 20%
    top: 100px
    // height: 70%
    background: #f2f2f2
    box-shadow: 0 0 10px 5px rgba(0,0,0,0.3)
    .color-box
      display: flex
      justify-content: flex-start
      align-items: center
      .color
        width: 100px
        height: 100px
        margin: 10px
        cursor: pointer
        position: relative
        box-shadow: 0 0 10px 5px rgba(0,0,0,0.3)
        img
          width: 100%
          height: 100%
          position: absolute
          top: 0
          left: 0
      .code
        padding-left: 5px
.img-fade-leave-active, .img-fade-enter-active
  transition: all .5s linear
.img-fade-leave-to, .img-fade-enter
  opacity: 0
</style>
